import React, { useMemo, useState } from "react";
import "./AIStore.css";
import Navbar from "../../Common/Navbar";

const projects = ["AI Landing Page", "Ecommerce Store", "Portfolio Site"];

const tools = [
  "📄 Prompt Templates",
  "🎨 Theme Builder",
  "🧩 Components",
  "⚙️ Settings",
];

function AIStore() {
  const [prompt, setPrompt] = useState("");
  const [activeProject, setActiveProject] = useState("AI Landing Page");
  const [history, setHistory] = useState([]);

  const previewTitle = useMemo(() => {
    return prompt.trim() ? prompt : "Live Preview Will Appear Here";
  }, [prompt]);

  const handleGenerate = () => {
    if (!prompt.trim()) return;

    setHistory((prev) => [
      `Generated task for ${activeProject}: ${prompt}`,
      ...prev,
    ]);

    setPrompt("");
  };

  return (
    <div className="ai-store-wrapper">
      <Navbar />

      <main className="ai-store-page">
        <aside className="ai-sidebar">
          <div className="sidebar-header">
            <div>
              <span className="sidebar-label">Workspace</span>
              <h3>📁 Projects</h3>
            </div>
            <button type="button">+ New</button>
          </div>

          <div className="project-list">
            {projects.map((project) => (
              <button
                key={project}
                type="button"
                className={`project-item ${
                  activeProject === project ? "active" : ""
                }`}
                onClick={() => setActiveProject(project)}
              >
                {project}
              </button>
            ))}
          </div>

          <div className="ai-tools-card">
            <h3>AI Tools</h3>
            <div className="tool-list">
              {tools.map((tool) => (
                <button type="button" key={tool}>
                  {tool}
                </button>
              ))}
            </div>
          </div>

          <div className="history-card">
            <h3>History</h3>
            {history.length === 0 ? (
              <p>No actions yet</p>
            ) : (
              history.map((item, index) => <span key={index}>{item}</span>)
            )}
          </div>
        </aside>

        <section className="ai-main">
          <div className="ai-hero">
            <div>
              <span className="ai-badge">AI Store Builder</span>
              <h1>Build with an AI agent</h1>
              <p>
                Create websites, dashboards, landing pages and store sections
                with AI-powered workflow.
              </p>
            </div>

            <div className="hero-actions">
              <button type="button">Quick setup</button>
              <button type="button">Customize ▼</button>
              <button type="button">Export</button>
            </div>
          </div>

          <div className="agent-panel">
            <div className="agent-panel-top">
              <h2>🤖 Build with an AI agent <span>New</span></h2>
              <div>
                <button type="button">▦ Prompt templates</button>
                <button type="button">⚙ Project context</button>
              </div>
            </div>

            <div className="agent-input-box">
              <input
                type="text"
                placeholder="Ask an agent to create a new page, build a dashboard, update an article..."
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
              />

              <div className="agent-input-bottom">
                <p>
                  Start from <strong>{activeProject}</strong> with{" "}
                  <strong>Claude Agent</strong>⌄
                </p>

                <div className="agent-icons">
                  <button type="button">🎙️</button>
                  <button type="button">📎</button>
                  <button type="button" onClick={handleGenerate}>
                    Run task
                  </button>
                </div>
              </div>
            </div>

            <p className="agent-note">
              The agent publishes changes in a preview - your live site won't
              change. <strong>Learn more ↗</strong>
            </p>
          </div>

          <div className="dashboard-grid">
            <div className="dashboard-card preview-card">
              <div className="card-title">
                <h3>🖥 Live Preview</h3>
                <span>{activeProject}</span>
              </div>

              <div className="preview-box">
                <h2>{previewTitle}</h2>
                <p>
                  Your AI generated website preview, sections, layout and
                  content will appear here.
                </p>
              </div>
            </div>

            <div className="dashboard-card">
              <div className="card-title">
                <h3>🚀 Production deploys</h3>
                <span>›</span>
              </div>

              <div className="deploy-box">
                <div>
                  <h4>Drag and drop your project folder here</h4>
                  <p>Deploy new changes or choose a folder to upload.</p>
                </div>
                <div className="folder-icon">📁</div>
              </div>
            </div>

            <div className="dashboard-card">
              <div className="card-title">
                <h3>📈 Observability</h3>
                <button type="button">Explore ›</button>
              </div>

              <div className="stats-row">
                <div>
                  <p>Last hour</p>
                  <h2>0 requests</h2>
                </div>

                <div>
                  <p>Errors</p>
                  <h2><span></span>0.00%</h2>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default AIStore;